import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ReactNode } from 'react';

type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
};

/** TDS tooltip — grey-900 표면 + 흰 라벨 + shadow-2, 짧은 보조 설명 */
export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <TooltipPrimitive.Root delayDuration={200}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className='z-50 max-w-72 rounded-s bg-fill-primary px-3 py-2 text-body-3 text-fg-inverse shadow-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0'
        >
          {content}
          <TooltipPrimitive.Arrow className='fill-fill-primary' />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}

export const TooltipProvider = TooltipPrimitive.Provider;
